import {
  Component,
  OnInit,
  ChangeDetectorRef,
  ChangeDetectionStrategy,
  OnDestroy,
} from '@angular/core';
import { BaseScaffoldComponent } from '../base-scaffold/base-scaffold.component';
import { RenderedService } from '../../rendered.service';
import { ViewPanelComponent } from '@scaffold/sidebars/view-panel/view-panel.component';
import {
  ScaffoldSidebarService,
  ScaffoldSidebarRef,
} from '@app/framework/sidebar/scaffold-sidebar.service';
import { TranslationService } from '@services/translation.service';

@Component({
    selector: 'scaffold-settings-panel',
    templateUrl: './settings-panel.component.html',
    styleUrls: ['./settings-panel.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class SettingsPanelComponent
  extends BaseScaffoldComponent
  implements OnInit, OnDestroy
{
  _sidebar: ScaffoldSidebarRef;
  constructor(
    public cdr: ChangeDetectorRef,
    public renderedService: RenderedService,
    private sidebar: ScaffoldSidebarService,
    private translationService: TranslationService
  ) {
    super(cdr, renderedService);
  }

  ngOnInit(): void {}

  ngOnDestroy(): void {
    if (this._sidebar?.close) this._sidebar.close();
  }

  openPanel() {
    if (this._sidebar) {
      this._sidebar.close();
      this._sidebar = null;
    }
    let heading;
    if (this.item.translation_key_heading) {
      heading = this.translationService.getTranslatedContent(
        this.item.translation_key_heading
      );
      heading = !this.item.text_transform_header
        ? heading
        : this.translationService.transform(
            heading,
            this.item.text_transform_heading
          );
    }
    this.item.panel_title = heading || this.item.panel_title;
    let config = {
      context: {
        info: this.info,
        view: this.item,
      },
    };
    this._sidebar = this.sidebar.open(ViewPanelComponent, config);
  }
}
